module.exports = __webpack_public_path__ + "static/media/utsystem.5a428310.png";